'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PagePromotionCta = exports.PagePromotionCtaUnwrapped = exports.mapStateToProps = exports.DEFAULT_PAGE_PROMOTION_SESSION_KEY = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _promotions = require('constants/promotions');

var _verify = require('helpers/verify');

var _page = require('redux/modules/page');

var _localStorage = require('redux/saga/helpers/local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_PAGE_PROMOTION_SESSION_KEY = exports.DEFAULT_PAGE_PROMOTION_SESSION_KEY = 'cpDefaultPagePromotion';

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    pagePromotionAlias: (0, _page.selectPagePromotion)(state)
  };
};

var PagePromotionCtaUnwrapped = exports.PagePromotionCtaUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(PagePromotionCtaUnwrapped, _PureComponent);

  function PagePromotionCtaUnwrapped() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PagePromotionCtaUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PagePromotionCtaUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(PagePromotionCtaUnwrapped)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sessionPromotionAlias: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PagePromotionCtaUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // This is done to achieve two things:
      // 1. A valid SSR vs CSR diff, without having to skip rendering of button on server.
      // 2. A re-render once it mounts on the client, if the session storage var exists.
      var sessionPromotionAlias = (0, _localStorage.readSessionStorage)(DEFAULT_PAGE_PROMOTION_SESSION_KEY, null, true);
      if (!(0, _verify.isBlank)(sessionPromotionAlias)) {
        this.setState({ sessionPromotionAlias: sessionPromotionAlias });
      }
    }
  }, {
    key: 'getPromotionAlias',
    value: function getPromotionAlias() {
      var pagePromotionAlias = this.props.pagePromotionAlias;
      var sessionPromotionAlias = this.state.sessionPromotionAlias;


      return pagePromotionAlias && pagePromotionAlias !== _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS ? pagePromotionAlias : sessionPromotionAlias || _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ctaCopy = _props.ctaCopy,
          extraClassForLink = _props.extraClassForLink,
          extraClassForWrapper = _props.extraClassForWrapper,
          handleClick = _props.onClick;


      return _react2.default.createElement(
        'div',
        { className: extraClassForWrapper },
        _react2.default.createElement(
          _reactRouter.Link,
          {
            className: (0, _classnames2.default)('bt', extraClassForLink),
            onClick: handleClick,
            to: '/pricing/' + this.getPromotionAlias()
          },
          ctaCopy || _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'page-promotion.cta.copy',
            defaultMessage: 'Start a free trial'
          })
        )
      );
    }
  }]);
  return PagePromotionCtaUnwrapped;
}(_react.PureComponent);

PagePromotionCtaUnwrapped.propTypes = {
  ctaCopy: _propTypes2.default.node,
  extraClassForLink: _propTypes2.default.string,
  extraClassForWrapper: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  pagePromotionAlias: _propTypes2.default.string
};

var PagePromotionCta = exports.PagePromotionCta = (0, _reactRedux.connect)(mapStateToProps)(PagePromotionCtaUnwrapped);